import { isClinicAdminRole } from "./dashboardMenu";

export const DEFAULT_PROTOCOL_PREFERENCES = {
  useProtocolNumber: false,
  allowNurseToSet: true,
  allowDoctorToSet: true,
  nextProtocolNumber: "",
};

/** Next value after the clinic counter. The last digits increase by 1. */
export function incrementProtocolNumber(value) {
  const text = String(value ?? "").trim();
  const match = text.match(/^(.*?)(\d+)$/);
  if (!match) return text;
  const prefix = match[1];
  const digits = match[2];
  const next = String(Number(digits) + 1);
  const padded = next.length < digits.length ? next.padStart(digits.length, "0") : next;
  return `${prefix}${padded}`;
}

export function parseProtocolPreferences(source) {
  const p =
    source?.protocolPreferences ??
    source?.ProtocolPreferences ??
    source ??
    {};
  return {
    useProtocolNumber: !!(p.useProtocolNumber ?? p.UseProtocolNumber),
    allowNurseToSet: p.allowNurseToSet ?? p.AllowNurseToSet ?? true,
    allowDoctorToSet: p.allowDoctorToSet ?? p.AllowDoctorToSet ?? true,
    nextProtocolNumber: String(p.nextProtocolNumber ?? p.NextProtocolNumber ?? "").trim(),
  };
}

export function buildProtocolPreferencesPayload(prefs) {
  if (!prefs) return undefined;
  return {
    UseProtocolNumber: !!prefs.useProtocolNumber,
    AllowNurseToSet: !!prefs.allowNurseToSet,
    AllowDoctorToSet: !!prefs.allowDoctorToSet,
  };
}

export function isProtocolRequired(prefs) {
  return !!parseProtocolPreferences(prefs).useProtocolNumber;
}

export function getCaseProtocolNumber(caseData) {
  const v = caseData?.protocolNumber ?? caseData?.ProtocolNumber;
  return v != null ? String(v).trim() : "";
}

export function hasCaseProtocolNumber(caseData) {
  return getCaseProtocolNumber(caseData).length > 0;
}

export function canEditProtocolOnCase(prefs, role) {
  const p = parseProtocolPreferences(prefs);
  if (!p.useProtocolNumber) return false;
  const r = String(role || "").toLowerCase();
  if (isClinicAdminRole(r) || r === "superadmin") return true;
  if (r === "nurse" && p.allowNurseToSet) return true;
  if (r === "doctor" && p.allowDoctorToSet) return true;
  return false;
}

export function protocolMissingMessage() {
  return "Numri i protokollit është i detyrueshëm për të mbyllur rastin. Vendoseni para përfundimit.";
}
